import React from "react";
import { ScoresByCPI } from "../ReconciliationModal";

export interface SummaryProps {
  cpi: number;
  acceptedTotal: number;
  rejectedTotal: number;
  acceptedIdsByCPI: ScoresByCPI;
  rejectedIdsByCPI: ScoresByCPI;
  avgCPI: number;
}

const summaryFromIdsByCPI = (idsByCPI: ScoresByCPI, summaryText: string) => {
  return Object.keys(idsByCPI).map((key) => {
    const count = idsByCPI[key].length;
    return (
      <li key={`${key}-${summaryText}`}>
        <span>
          {count} {summaryText} ${parseFloat(key).toFixed(2)}
        </span>
      </li>
    );
  });
};

export const Summary = ({
  cpi = 0.0,
  avgCPI = 0.0,
  acceptedTotal = 0.0,
  acceptedIdsByCPI,
  rejectedIdsByCPI,
  rejectedTotal = 0.0,
}: SummaryProps) => {
  const campaignSummary = React.useMemo(
    () => (
      <div className="campaign-summary spacing-top">
        <ul>
          <li data-testid="accepted-total">
            <span>
              <strong>Accepted total: </strong>${acceptedTotal.toFixed(2)}
            </span>
          </li>
          {!!avgCPI && (
            <li data-testid="average-cpi">
              <span>
                <strong>Average CPI: </strong>${avgCPI.toFixed(2)}
              </span>
            </li>
          )}
          {acceptedTotal > 0 && (
            <li>
              <ul className="completes-summary">
                {summaryFromIdsByCPI(acceptedIdsByCPI, "Completes at")}
              </ul>
            </li>
          )}
        </ul>
      </div>
    ),
    [avgCPI, acceptedIdsByCPI, acceptedTotal]
  );

  const rejectedSummary = React.useMemo(
    () => (
      <div className="rejected-summary spacing-top">
        <ul>
          <li data-testid="rejected-total">
            <strong>Rejected total: </strong>${rejectedTotal.toFixed(2)}
          </li>
          <li>
            <ul className="completes-summary">
              {summaryFromIdsByCPI(rejectedIdsByCPI, "Rejects at")}
            </ul>
          </li>
        </ul>
      </div>
    ),
    [rejectedTotal, rejectedIdsByCPI]
  );

  return (
    <>
      <div className="spacing-top">
        <strong>Final CPI: </strong>
        <span data-testid="final-cpi">${cpi.toFixed(2)}</span>
      </div>

      {acceptedTotal > 0 && rejectedSummary}
      {campaignSummary}
    </>
  );
};
